/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Event_Groups_RestoredInputs */



/**
* | output |
* | --- |
* | "Event groups restored successfully" |
*
* @param {Automatic_Save_Event_Groups_RestoredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_event_groups_restored = /** @type {((inputs?: Automatic_Save_Event_Groups_RestoredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Event_Groups_RestoredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupes d’événements restaurés avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisgruppen erfolgreich wiederhergestellt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppi di eventi ripristinati correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группы событий успешно восстановлены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupos de eventos restaurados exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件组已成功恢复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループが正常に復元されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह सफलतापूर्वक पुनर्स्थापित हो गए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupos de eventos restaurados com sucesso")
	return /** @type {LocalizedString} */ ("Event groups restored successfully")
});